import React from 'react';
import styles from '../../styles/careerkc.module.scss';

interface cardProps {
  bgColor: string;
  title: string;
  titleColor: string;
  subTitle: string;
}

const CustomGalleryCard: React.FC<cardProps> = ({ bgColor, title, titleColor, subTitle }) => {
  return (
    <div  className={styles.customCard}  style={{ backgroundColor: bgColor }}>
      <h3   style={{ color: titleColor }}>{title}</h3>
      <p>{subTitle}</p>
    </div>
  )
}

export default CustomGalleryCard;